<template>
  <div
    id="RichText"
    contenteditable="true"
    @input="update"
    @blur="update"
    @paste="handlePaste"
    ref="element"
  />
</template>

<script setup>
import useDraftsMsg from '@/views/WorkPlace/Container/chat/hooks/useDraftsMsg.js'
import { defineProps, ref, onMounted, watch, defineEmits, defineExpose } from 'vue'
import useCommonWords from '../../hooks/useComonWords'
import { isEmoji, onlyID } from './clipboard'
import { message } from 'ant-design-vue'
const { insertContent } = useCommonWords()
const { saveFile, getFiles } = useDraftsMsg()
const props = defineProps({
  modelValue: String,
  activeKey: String
})

const emit = defineEmits({
  returned: String,
  'update:modelValue': String
})

const element = ref(null)
// 如果既有图片
const sendImgs = ref([])

function currentContent() {
  return element.value?.innerHTML
}
// 黏贴图片事件
function handlePaste(e) {
  // 移除格式 否则会好几层嵌套
  e.preventDefault()
  const SIZE = 10 * 1024 * 1024
  const CD = e.clipboardData || window.clipboardData
  // console.log(CD)
  // 没有黏贴东西
  if (!CD) return
  const items = Array.from(CD.items)
  // 如果没有黏贴数据直接退出
  if (!items) return
  for (let index = 0; index < items.length; index++) {
    const item = items[index]
    // 复制的内容 (只支持图片 和 文案)
    const pasteType = item.kind
    // NOTE: 图片
    if (pasteType === 'file' && item.type.startsWith('image/')) {
      const file = item.getAsFile()
      if (file.size < SIZE) {
        pasteImg(file, index)
      } else {
        message.error('图片格式仅支持png/jpg/jpeg / 图片仅限10M以内')
      }
    }
    // NOTE:文本
    else if (item.kind === 'string' && item.type === 'text/plain') {
      item.getAsString(stringData => {
        if (stringData) pasteText(stringData, index)
      })
    }
  }
}
// 复制的内容是 图片
function pasteImg(file, id) {
  // 创建文件流，图片转成 base64 的格式放入img中
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = e => {
    const base64 = e.target.result
    const img = document.createElement('img')
    img.id = 'img-' + onlyID()
    img.src = base64
    img.style.width = '100px' // 设置图片宽度
    img.style.height = '50px' // 设置图片高度
    img.style.margin = '0 5px'
    element.value.append(img)
    // 记录添加的图片
    sendImgs.value.push({ type: 'img', id: img.id, content: base64 })
    saveFile(props.activeKey, sendImgs.value)
    // 插入节点
    insertContent(img)
  }
}
// 复制内容是 文本
function pasteText(text, id) {
  const span = document.createElement('span')
  span.id = 'span-' + onlyID()
  span.innerText = text
  // 插入节点
  insertContent(span)
}
// 将数据过滤出
function getSendsData() {
  let send = []
  const childNodes = element.value.childNodes
  // 递归函数
  const deepChild = childNodes => {
    // 临时存储
    childNodes.forEach((node, index) => {
      const { nodeName } = node
      if (nodeName === '#text') {
        node.data && send.push({ type: 'text', content: node.data })
      } else if (nodeName === 'IMG') {
        const sendImg = sendImgs.value.find(sendImg => sendImg.id === node.id)
        const isEmj = isEmoji(node.src)
        // 要么是正常图片要么是 emoji 图片
        sendImg && send.push({ type: 'img', content: sendImg.content })
        isEmj && send.push({ type: 'text', content: node.outerHTML })
      } else if (nodeName === 'BR') {
        send.push({ type: 'text', content: '\n' })
      } else if (nodeName === 'SPAN' && node.childNodes.length) {
        deepChild(node.childNodes)
      }
    })
  }
  // 合并内容，并清空重复类型的内容。
  const merge = () => {
    // 当前操作第几个
    const sendLen = send.length
    for (let index = 0; index < sendLen; index++) {
      const sendOne = send[index]
      // 这个是操作清空的循环
      for (let operator = index + 1; operator < sendLen; operator++) {
        // 被操作的项
        const operated = send[operator]
        // 如果下一个元素是 img, 那么进行记录索引，（下一个还是的话继续记录）
        if (operated.type === 'text') {
          sendOne.content += operated.content
          operated.content = ''
        } else {
          // 将位置定位到图片索引，开始下一轮
          index = operator
          break
        }
      }
    }
    send = send.filter(f => f.content)
  }
  // 递归便利出嵌套元素
  deepChild(childNodes)
  // 将类型相同的 text 进行合并
  merge()
  return send
}
const updateContent = newContent => {
  element.value.innerHTML = newContent
}

function update() {
  console.log('更新内容')
  emit('update:modelValue', currentContent())
}

onMounted(() => {
  // update()
  updateContent(props.modelValue || '')
})

watch(
  () => props.modelValue,
  newVal => {
    if (newVal != currentContent()) {
      updateContent(newVal || '')
    }
  }
)
watch(
  () => props.activeKey,
  activeKey => {
    sendImgs.value = getFiles(activeKey)
  },
  {
    immediate: true
  }
)
defineExpose({ update, getSendsData })
</script>
